import { isPlatform } from '@ionic/react';

export const DEFAULT_TOAST_DURATION = 3000;
export const DEFAULT_ROLES = ["SEARCH"];
export const DEFAULT_PAGE_SIZE = isPlatform("desktop") || isPlatform("tablet") ? 8 : 3;
export const DEFAULT_PHOTO_QUALITY = 50;
export const CAMERA_OVERLAY_STYLE = isPlatform("tablet") ? {"--height": "100%", "--width": "100%",} : {};
export const ION_TEXT_TABLET_STYLE = isPlatform("tablet") ? { fontSize: "2rem" } : {};
